// src/Api/loginApi.js
import { post } from "./api";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

const useLogin = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);
  const navigate = useNavigate();

  const login = async (email, password) => {
    setLoading(true);
    setError(null);

    try {
      const response = await post("/login", { email, password });

      if (response?.accessToken && response?.refreshToken) {
        localStorage.setItem("accessToken", response.accessToken);
        localStorage.setItem("refreshToken", response.refreshToken);
        localStorage.setItem("loginData", JSON.stringify(response));

        setData(response);
        navigate("/dashboard", { replace: true }); // ← Changed from "/" to "/dashboard"
      }

      return response;
    } catch (error) {
      const serverMessage =
        error?.response?.data?.message ||
        error?.response?.data ||
        "Login failed";

      setError(serverMessage);

      // Clear tokens if login fails
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("loginData");

      return null;
    } finally {
      setLoading(false);
    }
  };

  return { login, loading, error, data };
};

export default useLogin;
